import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";
import { formatFilterForQueryParam } from "src/common/service";

class CompanyDataAccess {
  getSupplierForAudits(ProcedureId: any) {
    return commonDataAccess.getData("company/get/supplierforaudits/", {
      procedureId: ProcedureId,
    });
  }
  saveSupplierForAudits(ProcedureId: any, supplierIds: any) {
    return commonDataAccess.postData("company/save/supplierforaudits", {
      procedureId: ProcedureId,
      supplierIds: supplierIds,
    });
  }
  getSupplierAudits(supplierId: any) {
    return commonDataAccess.getData(
      "company/get/supplier-audits/" + supplierId,
    );
  }
  getSupplierContacts(supplierId: any) {
    return commonDataAccess.getData(
      "company/get/supplier-contacts/" + supplierId,
    );
  }
  saveSupplierContacts = async (data: any) => {
    var result = await commonDataAccess.postData(
      "company/save/supplier-cantact",
      data,
    );
    return result;
  };
  importSupplier(payload: any) {
    return commonDataAccess.postData(
      "company/import/supplier-exceldata",
      payload,
    );
  }
  getSupplierReviewDateList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "company/get/overdue-review-dates",
      parameters,
    );
  };
  exportSupplierDataToExcel() {
    return commonDataAccess.downloadFile("company/get/supplierreexportdetails");
  }
  exportCustomerDataToExcel() {
    return commonDataAccess.downloadFile("company/get/customerexportdetails");
  }
  saveCustomerProducts = (payload: any) => {
    return commonDataAccess.postData(`company/save/customerProducts`, payload);
  };
  getCompaniesForDropdownByType = (
    serviceType: "supplier" | "customer",
    searchValue: any = "",
    selectedSupplierIds: any = "",
  ) => {
    let type = serviceType === "supplier" ? 1 : 2;
    return commonDataAccess.getData("company/get/DropdownListByType", {
      type: type,
      searchValue: searchValue,
      selectedIdsString: selectedSupplierIds,
    });
  };

  getCodeDropdownListByType = (serviceType: "supplier" | "customer") => {
    let type = serviceType === "supplier" ? 1 : 2;
    return commonDataAccess.getData("company/get/codeDropdownListByType", {
      type: type,
    });
  };

  getServiceCompanyDropdown = () => {
    return commonDataAccess.getData("company/get/serviceCompanyDropdown");
  };
  getdelivererDropdown = () => {
    return commonDataAccess.getData("company/get/delivererDropdown");
  };

  supplierList = async (
    params: {
      pageNo;
      pageSize;
      sortData;
      filters: Array<IFilter>;
    },
    moduleName,
  ) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "company/get/supplierAll",
      parameters,
      moduleName,
    );
  };

  getSupplierBasicInfo = async (
    params: { id: number | bigint },
    moduleName: string,
  ) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierBasicInfo/" + params,
      {},
      moduleName,
    );

    return result;
  };

  getCustomerInfo = async (
    params: { id: number | bigint },
    moduleName: string,
  ) => {
    var result = await commonDataAccess.getData(
      "company/get/customerInfo/" + params,
      {},
      moduleName,
    );

    return result;
  };
  getSupplierExpiryDates = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierExpiryDates/" + params,
      {},
    );
    return result;
  };
  getCompanyTelephone = async (params: { companyId: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/companyTelephone/" + params,
      {},
    );
    return result;
  };
  saveSupplierBasicInfo = async (data: any, moduleName: string) => {
    var result = await commonDataAccess.postData(
      "company/save/supplierBasicInfo",
      data,
      {},
      null,
      moduleName,
    );
    return result;
  };
  saveCustomerInfo = async (data: any, moduleName) => {
    var result = await commonDataAccess.postData(
      "company/save/customerInfo",
      data,
      {},
      null,
      moduleName,
    );
    return result;
  };
  saveSupplierExpiryDates = async (data: any) => {
    var result = await commonDataAccess.postData(
      "company/save/supplierExpiryDates",
      data,
    );
    return result;
  };
  getSupplierAdditionalNotes = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/additional-notes/" + params,
      {},
    );
    return result;
  };
  saveSupplierAdditionalNotes = async (data: any) => {
    var result = await commonDataAccess.postData(
      "company/save/additional-notes",
      data,
    );
    return result;
  };
  getSupplierAttachmentInfo = async (id: number) => {
    var result = await commonDataAccess.getData(
      `company/get/attachment-info/${id}`,
      {},
    );
    return result;
  };
  saveSupplierAttachment = async (data: any) => {
    var result = await commonDataAccess.postData(
      "company/save/attachment",
      data,
    );
    return result;
  };
  savePublicSupplierAttachment = async (data: any, organizationId: number) => {
    var result = await commonDataAccess.postData(
      "company/save/public/certificate",
      data,
      { organizationId: organizationId },
    );
    return result;
  };
  getSupplierSites = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierSites/" + params,
      {},
    );
    return result;
  };
  getSupplierGoodsInType = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierGoodsInType/" + params,
      {},
    );
    return result;
  };
  saveSupplierSites = (data: any, supplierId: number) => {
    return commonDataAccess.postData("company/save/supplierSites", data, {
      supplierId: supplierId,
    });
  };
  getSupplierProducts = (id: number) => {
    return commonDataAccess.getData(`company/get/supplierProducts/${id}`);
  };
  getCustomerProducts = (id: number) => {
    return commonDataAccess.getData(`company/get/customerProducts/${id}`);
  };
  getCustomerProductDetail = (customerId: number, productId: number) => {
    return commonDataAccess.getData(
      `company/get/productDetailsForCustomer/${customerId}/${productId}`,
    );
  };
  deleteSupplierSites = async (params: { id: number | bigint }) => {
    return commonDataAccess.deleteData(
      "company/delete/supplierSites/" + params,
    );
  };
  saveSupplierProducts = (payload: any) => {
    return commonDataAccess.postData(`company/save/supplierProducts`, payload);
  };
  deleteSupplierProduct = (id: number) => {
    return commonDataAccess.deleteData(`company/delete/supplierProducts/${id}`);
  };
  deleteCustomerProduct = (id: number) => {
    return commonDataAccess.deleteData(`company/delete/customerProducts/${id}`);
  };
  getSuppliersWithPriceByProduct = (id: number) => {
    return commonDataAccess.getData(
      `company/get/suppliersWithPriceByProduct/${id}`,
    );
  };
  getSupplierDocuments = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierDocuments/" + params,
      {},
    );
    return result;
  };
  saveSupplierDocuments = (data: any, supplierId: number) => {
    return commonDataAccess.postData("company/save/supplierDocuments", data, {
      supplierId: supplierId,
    });
  };
  deleteSupplierDocuments = async (params: { id: number | bigint }) => {
    return commonDataAccess.deleteData(
      "company/delete/supplierDocuments/" + params,
    );
  };
  deleteSupplier = async (params: { ids: string }, moduleName: string) => {
    var result = await commonDataAccess.deleteData(
      "company/delete/" + params,
      {},
      moduleName,
    );
    return result;
  };
  getSupplierGlobalGAPExpiryDates = (id: number) => {
    return commonDataAccess.getData(`company/get/gobalGAPExpiryDates/${id}`);
  };
  saveSupplierGlobalGAPExpiryDates = (modal: any[]) => {
    return commonDataAccess.postData(`company/save/gobalGAPExpiryDates`, modal);
  };
  getOverdueEmailRecipientsEmployeeDepartments = (
    entityId: number,
    isUser: boolean,
  ) => {
    return commonDataAccess.getData(
      "company/get/overdueEmailRecipientsUserorDepartments",
      {
        id: entityId,
        isUser: isUser,
      },
    );
  };
  saveOverdueEmailRecipientsEmployeeDepartments = (
    entityId: number | bigint,
    selectedUsers: string,
    selectedDepts: string,
  ) => {
    return commonDataAccess.postData(
      "company/save/overdueEmailRecipientsUserorDepartments",
      null,
      {
        entityId: entityId,
        selectedDepartmentIds: selectedDepts,
        selectedUserIds: selectedUsers,
      },
    );
  };
  getSupplierReviewEmailRecipientsEmployeeDepartments = (
    entityId: number,
    isUser: boolean,
  ) => {
    return commonDataAccess.getData(
      "company/get/SupplierReviewEmailRecipientsUserorDepartments",
      {
        id: entityId,
        isUser: isUser,
      },
    );
  };
  saveSupplierReviewEmailRecipientsEmployeeDepartments = (
    entityId: number | bigint,
    selectedUsers: string,
    selectedDepts: string,
  ) => {
    return commonDataAccess.postData(
      "company/save/SupplierReviewEmailRecipientsUserorDepartments",
      null,
      {
        entityId: entityId,
        selectedDepartmentIds: selectedDepts,
        selectedUserIds: selectedUsers,
      },
    );
  };
  getCompanyDeliveryLocation = (comapnyId) => {
    return commonDataAccess.getData("company/get/companydeliverylocation", {
      id: comapnyId,
    });
  };

  sendOverdueCertificateEmail = (payload: {
    supplierId: number;
    dateFieldName: string;
    dateFieldText: string;
  }) => {
    console.log(payload);
    return commonDataAccess.postData(
      "company/supplier/send-overdue-email",
      payload,
    );
  };

  getSupplierRiskAnalysis = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierRiskAnalysis/" + params,
      {},
    );
    return result;
  };

  saveSupplierRiskAnalysis = async (data: any) => {
    var result = await commonDataAccess.postData(
      "company/save/supplierRiskAnalysis",
      data,
    );
    return result;
  };

  getSupplierRequests = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierRequests/" + params,
      {},
    );
    return result;
  };

  saveSupplierRequest = async (data: any) => {
    var result = await commonDataAccess.postData(
      "company/save/supplierRequest",
      data,
    );
    return result;
  };

  getSupplierRequestById = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "company/get/supplierRequestById/" + params,
    );
    return result;
  };

  deleteSupplierRequest = async (params: { id: number }) => {
    var result = await commonDataAccess.deleteData(
      "company/delete/supplierRequestById/" + params,
    );
    return result;
  };

  getSupplierMainMenuAuditList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = formatFilterForQueryParam(params?.filters);

    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "company/get/supplier/supplierMainMenuAuditList",
      parameters,
    );
  };

  getSupplierMainMenuAuditDateList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = formatFilterForQueryParam(params?.filters);

    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "company/get/supplier/supplierMainMenuAuditDateList",
      parameters,
    );
  };

  getSupplierMainMenuQuestionnaireList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = formatFilterForQueryParam(params?.filters);

    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "company/get/supplier/supplierMainMenuQuestionnaires",
      parameters,
    );
  };

  getSupplierMainMenuRiskAnalysisList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = formatFilterForQueryParam(params?.filters);

    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "company/get/supplier/supplierMainMenuRiskAnalysis",
      parameters,
    );
  };

  getSupplierMainMenuRequestsList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = formatFilterForQueryParam(params?.filters);

    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "company/get/supplier/supplierMainMenuRequests",
      parameters,
    );
  };

  getDropdownForContactName = (id: number) => {
    return commonDataAccess.getData("company/get/contactNameDropdownList", {
      id: id,
    });
  };

  saveSupplierCertificate = async (data: any) => {
    return commonDataAccess.postData("company/save/supplierCertificates", data);
  };

  getSupplierCertificates = (supplierId: number) => {
    return commonDataAccess.getData("company/get/supplierCertificates", {
      supplierId: supplierId,
    });
  };

  getSupplierCertificateDetails = (id: number) => {
    return commonDataAccess.getData(
      "company/get/getSupplierCertificateDetails",
      {
        id: id,
      },
    );
  };

  requestCertificateToBeUploaded = (data: any) => {
    return commonDataAccess.postData(
      "company/certificate/request-certificate-upload",
      data,
    );
  };

  notifyRecipientToUpload = (data: any) => {
    return commonDataAccess.postData(
      "company/certificate/notify-recipient-to-upload",
      data,
    );
  };
  verifyCertificateTokenAndGetDetails = (params: {
    supplierId: number;
    certificateType: number;
    token: string;
  }) => {
    return commonDataAccess.postData(
      "CertificateProcess/verify/certificate-token",
      params,
    );
  };

  uploadSupplierCertificate = (data: any) => {
    return commonDataAccess.postData(
      "CertificateProcess/save/supplierCertificate",
      data,
    );
  };

  getCertificateUploadBasicInfo = (
    supplierId: number,
    certificateType: number,
  ) => {
    return commonDataAccess.getData("CertificateProcess/get/basicInfo", {
      supplierId: supplierId,
      certificateType: certificateType,
    });
  };

  approveSupplierCertificate = (params: {
    certificateId: number;
    supplierId: number;
    temporaryClassType: string;
    finalClassType: string;
  }) => {
    return commonDataAccess.postData(
      "company/approve-supplier-certificate",
      null,
      params,
    );
  };

  rejectSupplierCertificate = (params: { certificateId: number }) => {
    return commonDataAccess.postData(
      "company/reject-supplier-certificate",
      null,
      params,
    );
  };
}
export default new CompanyDataAccess();
